import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';

import Header from '@components/Header';
import RowIsMore from '@components/RowIsMore';

import { getAllEmails } from '@actions/emails'

import { StatusVisible } from '@constants/general'
import { getValueLanguageObj } from '@utils/general'
// import './style.scss'

class Emails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingTable: true,
      emails: [],
      emailsByPage: [],
      allEmails: [],
      emailsTotal: 0,
      filterText: '',
      lazyParams: {
        first: 0,
        rows: 10,
        page: 0,
      }
    };
  }

  async componentDidMount() {
    await this.loadData();
  }


  loadData = async () => {
    const { getAllEmails, isFullAdmin } = this.props;
    this.setState({ loadingTable: true });
    const response = await getAllEmails();
    if (!response?.status) {
      let allEmails = response.data
      if (!isFullAdmin) {
        allEmails = allEmails.filter(email => email.activo)
      }
      return this.setState({
        allEmails,
        emails: allEmails,
        emailsByPage: allEmails,
        emailsTotal: allEmails.length,
        loadingTable: false,
      });
    }
    return this.setState({ loadingTable: false });
  };

  searchData = () => {
    const { allEmails, filterText } = this.state
    if (filterText) {
      const getFilterData = allEmails.reduce((accum, item) => {
        if (item?.nombre && item.nombre.toUpperCase().includes(filterText.toUpperCase())) {console.log('Nombre', item.nombre.toUpperCase()); accum.push(item)}
        else if (item?.descripcion && item.descripcion.toUpperCase().includes(filterText.toUpperCase())) {console.log('descripcion'); accum.push(item)}
        else if (item?.asunto && getValueLanguageObj(JSON.parse(item.asunto)).toUpperCase().includes(filterText.toUpperCase())) {console.log('Asunto');accum.push(item)}
        return accum
      }, [])

      return this.setState({
        emailsByPage: getFilterData,
        emails: getFilterData,
        emailsTotal: getFilterData.length,
        lazyParams: {
          first: 0,
          rows: 10,
          page: 0,
        }
      })
    }
    return  this.setState({
      emails: allEmails,
      emailsByPage: allEmails,
      emailsTotal: allEmails.length,
      lazyParams: {
        first: 0,
        rows: 10,
        page: 0,
      }
    })
  }

  loadDataByPage = () => {
    const { lazyParams, emails } = this.state
    const dataPage = emails.slice(lazyParams.first, (lazyParams.first + lazyParams.rows))
    this.setState({ emailsByPage: dataPage })
  }

  onChange = ({target}) => {
    this.setState({[target.name]: target.value});
  };


  onPage = (event) => {
    const { lazyParams } = this.state;
    const _lazyParams = { ...lazyParams, ...event };
    this.setState({ lazyParams: _lazyParams }, this.loadDataByPage);
  };

  templateEdit = (node, detail) => (
    <div>
      <span className="p-column-title">{detail.header}</span>
      <Button
        type="button"
        icon="pi pi-pencil"
        className="p-button-text"
        style={{ marginRight: '.5em' }}
        onClick={() => this.props.history.push( {pathname: "/email/edit", state: {clearCache: true, id: node.id}})}
      />
    </div>
  );


  columnResponsive = (rowData, detail) => (
    <>
        <span className="p-column-title">{detail.header}</span>
        {rowData[detail.field]}
    </>
  )

  columnAsunto = (rowData, detail) => {
    const getAsunto = getValueLanguageObj(JSON.parse(rowData.asunto))
    return (
    <>
        <span className="p-column-title">{detail.header}</span>
        <RowIsMore
        text={getAsunto}
      />
    </>
  )}

  columnDescription = (rowData, detail) => (
      <>
        <span className="p-column-title">{detail.header}</span>
        <RowIsMore
          text={rowData.descripcion}
        />
      </>
      )

  templateEstatus = (node, detail) => {
    const { t } = this.props
    if (node.activo) {
      return (
        <div className="p-text-center-lg">
          <span className="p-column-title">{detail.header}</span>
          <i className="pi pi-check" />
        </div>
      );
    }
      return (
        <>
          <span className="p-column-title">{detail.header}</span>
          <span className={`badge-red cursor-not-pointer`} aria-hidden="true" > {t('OCULTA')} </span>
        </>
      );
  }

  render() {
    const { history, t, isFullAdmin } = this.props;
    const { loadingTable, emails, lazyParams, filterText, emailsTotal, emailsByPage } = this.state;

    const rightHeader = (
      <>
        <Button
          icon="pi pi-th-large"
          className="p-button-raised p-button-text p-button-plain"
          onClick={() => history.push('/dashboard')}
        />
        { isFullAdmin && (
          <Button
            label={t('Agregar Correo')}
            className="p-button-primary"
            onClick={() => history.push( {pathname: "/email/new", state: {clearCache: true}})}
          />
        )
        }
      </>
    );

    return (
      <div className="p-grid">
        <div className="p-col-12">
          <Header title={t('Correos')} rightComponent={rightHeader} />
          <div className="card p-grid">
            <div className="p-col-12 p-md-12 p-lg-12 p-d-flex p-ai-center p-jc-start">
              <label className="p-mr-2 p-text-bold">{t('Texto')}:</label>
              <InputText
                name="filterText"
                value={filterText}
                onChange={this.onChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") this.searchData()
                }}
              />
              <Button
                icon="pi pi-search"
                label={t('Buscar')}
                className="p-button-raised p-button-text p-button-plain btn-search-list p-ml-3"
                onClick={() => this.searchData()}
              />
            </div>
            <div className="p-col-12 p-mt-2">
              <DataTable
                value={emailsByPage}
                lazy
                loading={loadingTable}
                className="table-languages"
                paginator={!!emails}
                rows={lazyParams.rows}
                totalRecords={emailsTotal}
                first={lazyParams.first}
                onPage={this.onPage}
              >
                <Column
                  header={t('Id')}
                  field="id"
                  body={this.columnResponsive}
                  className="column-action p-mr-4"
                />
                <Column
                  header={t('Nombre')}
                  field="nombre"
                  body={this.columnResponsive}
                />
                <Column
                  header={t('Asunto')}
                  body={this.columnAsunto}
                  // className="column-max p-text-center-lg"
                />
                <Column
                  header={t('Descripción')}
                  body={this.columnDescription}
                />
                {isFullAdmin && (
                  <Column
                    header={t('Visible')}
                    field="descripcion"
                    body={this.templateEstatus}
                    className="column-action p-mr-4"
                  />
                )}
                <Column
                  header={t('Editar')}
                  body={this.templateEdit}
                  className="column-action p-text-center-lg"
                />
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isFullAdmin: state.settings.isFullAdmin,
});

const mapDispatchToProps = {
  getAllEmails
};

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(Emails);
